import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './resource/dragging-image@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-7b8d06e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dragging-mask" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"dragging-mask__border\" data-v-7b8d06e6></div><div class=\"dragging-mask__content\" data-v-7b8d06e6><img class=\"dragging-mask__content__figure\" src=\"" + _imports_0 + "\" alt=\"drag\" data-v-7b8d06e6><div class=\"dragging-mask__content__title\" data-v-7b8d06e6>Drop your image here</div><div class=\"dragging-mask__content__tip\" data-v-7b8d06e6>Supports：JPG、PNG</div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}